import {
  Constraint as ConstraintAPI,
  LocationInState as LocationInStateAPI,
  RequiresActivation as RequiresActivationAPI,
} from '@occc-app/Activate/apiTypes';

import {
  Constraints as ConstraintsClient,
  ConstraintKeys,
  LocationInState,
  RequiresActivation,
} from './types';

type DeserializeConstraintType = (
  constraintType: ConstraintAPI['attributes']['constraint_type'],
) => ConstraintKeys;
export const deserializeConstraintType: DeserializeConstraintType = (constraintType) => {
  switch (constraintType) {
    case 'location_in_state':
      return 'locationInState';
    case 'requires_activation':
      return 'requiresActivation';
    default:
      throw new Error('Unsupported constraintType');
  }
};

type DeserializeLocationInState = (constraintBody: LocationInStateAPI) => LocationInState;
const deserializeLocationInState: DeserializeLocationInState = (constraintBody) => ({
  type: 'locationInState',
  active: true,
  states: constraintBody.configuration.states,
});

type DeserializeRequiresActivation = (constraintBody: RequiresActivationAPI) => RequiresActivation;
const deserializeRequiresActivation: DeserializeRequiresActivation = (constraintBody) => ({
  type: 'requiresActivation',
  active: true,
  mustFulfillWithinDays: constraintBody.configuration.must_fulfill_within_days || 0,
  mustFulfillWithinDaysActive: !!constraintBody.configuration.must_fulfill_within_days,
});

type DeserializeConstraint = (constraintBody: ConstraintAPI) => ConstraintsClient;
export const deserializeConstraint: DeserializeConstraint = (constraintBody) => {
  switch (constraintBody.attributes.constraint_type) {
    case 'location_in_state':
      return deserializeLocationInState(constraintBody.attributes);
    case 'requires_activation':
      return deserializeRequiresActivation(constraintBody.attributes);
    default:
      throw new Error('Unsupported constraintType');
  }
};
